import { uniqBy, sortBy } from 'lodash';
import { commaizeInt, ceil } from './pricing';

export const productTypeToText = (productType = '') => (
  productType
    .split('_')
    .map(t => `${t[0].toUpperCase()}${t.slice(1)}`)
    .join(' ')
);

export function isMultiTier(trip) {
  if (trip.multi_tier_prices && trip.multi_tier_prices.length > 0) return true;
  return false;
}

export function getTripPrice(trip, { quantity = 1, rates, currency = 'THB' }, omitBookingFee = true) {
  let price = 0;
  const fullPrices = trip.full_prices;
  if (Array.isArray(fullPrices)) {
    const index = quantity > fullPrices.length ? fullPrices.length - 1 : quantity - 1;
    const priceObj = fullPrices[index];
    price = omitBookingFee ? priceObj.seasonedDiscountedPerPerson : priceObj.displayPrice;
  } else {
    price = omitBookingFee
      ? fullPrices.seasonedDiscountedPerPerson
      : fullPrices.displayPrice;
  }
  return commaizeInt(
    ceil(
      price,
      currency,
      rates,
      true
    )
  );
}

export function getStartTicketPrice(data, { rates, currency }) {
  const priceConvert = price => commaizeInt(
    ceil(
      price,
      currency,
      rates,
      true
    )
  );
  let price = 0;
  let crossPrice;
  if (data.display_price) price = data.display_price;
  else if (isMultiTier(data)) {
    let minPrice;
    data.multi_tier_prices.forEach(tier => {
      tier.sub_tiers.forEach(st => {
        if (!minPrice) minPrice = st.price;
        if (st.price < minPrice) {
          minPrice = st.price;
          if (st.display_price) {
            crossPrice = st.display_price;
          }
        }
      });
    });
    price = minPrice;
  }
  return {
    price: priceConvert(price),
    display_price: priceConvert(crossPrice)
  };
}

export function getChildPriceObj(additionalOptions) {
  return additionalOptions.find(o => o.key === 'children');
}

export function getHotelObj(additionalOptions) {
  return additionalOptions.find(o => o.key === 'hotel');
}

export function getSelectedTier(multiTier = [], tierName) {
  return multiTier.find(t => t.tier === tierName);
}

export function getTripDuration(trip) {
  if (!trip.duration) return '';
  return trip.duration.split(' hours')[0];
}

export function hasTag(trip, searchTag) {
  return !!trip.tags.find(t => t === searchTag);
}

export function isDtacSIM(trip) {
  return trip.product_type === 'souvenir' && hasTag(trip, 'dtac_sim');
}

export function isRequireDeliveryLocation(trip) {
  return (
    trip.product_type === 'souvenir' &&
    hasTag(trip, 'dtac_sim') &&
    !hasTag(trip, 'not_require_pickup_location')
  );
}

export function isMatchPassportName(trip) {
  return hasTag(trip, 'match_passport_name');
}

export function isRequireDate(trip) {
  if (trip.is_date_not_required === true || trip.is_date_not_required === false) return !trip.is_date_not_required;
  return true;
}

export const isRequireMeetingPoint = (trip) => {
  return !trip.is_hide_meeting_point;
};

export function getDistinctQuestions(selectedTier) {
  return uniqBy(
    selectedTier.sub_tiers
      .map(st => st.globaltix_questions)
      .filter(st => !!st)
      .reduce((prev, curr) => [...prev, ...curr], []),
    question => question.id
  );
}

export const mergeMeetingPoints = (productMeetingPoints, allMeetingPoints) => {
  const formattedMeetingPoints = productMeetingPoints.reduce((stations, mp) => {
    if (mp.name === 'Any Station') {
      if (mp.type === 'Airport Rail Link Station') return stations.concat(allMeetingPoints.arl);
      if (mp.type === 'MRT Station') return stations.concat(allMeetingPoints.mrt);
      if (mp.type === 'BTS Station') return stations.concat(allMeetingPoints.bts);
    }
    if (mp.type === 'Hotel Pickup') stations.push({ label: `${mp.type} (${mp.city})`, value: `${mp.type} (${mp.city})`});
    else stations.push({ label: `${mp.type} - ${mp.name}`, value: `${mp.type} - ${mp.name}`});
    return stations;
  }, []);
  return sortBy(formattedMeetingPoints, ['label']);
};




// WEBPACK FOOTER //
// ./src/utils/product.js